import { h } from "preact";

import { Box, Button, DialogActions, DialogContent, Dialog, DialogTitle, Typography } from "@mui/material";

export default function SellerOnboardedDialog(props) {
	const handleClose = () => {
		props.onClose();
	};

	const acceptDealAsAmbassador = (uid) => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/03671a75223041338c84302d2a520c5c/", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						//window.location.reload();
						window.location.href = "/dashboard"
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};

	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">
				<Typography variant="h5" gutterBottom>
					Félicitations
				</Typography>
			</DialogTitle>
			<DialogContent dividers>
				<Typography variant="body1">Vous avez complété votre profil vendeur.</Typography>
				<Typography variant="body1">Voulez-vous aller au tableau de bord ?</Typography>
			</DialogContent>
			<DialogActions>
				<Box display="flex" justifyContent="center" style="width: 100%">
					{/* <Box>
						<Button onClick={handleClose}>Ferme</Button>
					</Box> */}
					<Box>
						<Button onClick={() => {
							acceptDealAsAmbassador();

						}} variant="contained">
							Aller à mon tableau de bord
						</Button>
					</Box>
				</Box>
			</DialogActions>
		</Dialog>
	);
}
